"use strict";

require("core-js/modules/es.object.define-property.js");
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _nativeAdapter = _interopRequireDefault(require("@zz-common/native-adapter"));
/**
 * @function
 * @name Native - @zz-common/native-adapter
 * @desc 替代 @zz-common/native-adapter，能够直接使用其所有方法，文档地址：<a href="http://192.168.171.50:8058/Native.html" target="_blank">http://192.168.171.50:8058/Native.html</a>
 * @example
 * import { Native } from '@zz-biz/adapter';
 * 
 * // 例如设置标题
 * Native.setTitle();
 */
var _default = _nativeAdapter["default"];
exports["default"] = _default;